import { render, staticRenderFns } from "./LinhaDeVinculos.vue?vue&type=template&id=805fe55e&scoped=true"
import script from "./LinhaDeVinculos.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeVinculos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeVinculos.vue?vue&type=style&index=0&id=805fe55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805fe55e",
  null
  
)

export default component.exports